import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useAdminData = () => {
  const [contacts, setContacts] = useState([]);
  const [intakes, setIntakes] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  // Note: API is a module-level constant, setters are stable per React
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [cRes, iRes, aRes] = await Promise.all([
        axios.get(`${API}/contact`),
        axios.get(`${API}/intake`),
        axios.get(`${API}/appointments`),
      ]);
      setContacts(cRes.data);
      setIntakes(iRes.data);
      setAppointments(aRes.data);
    } catch {
      toast.error('Failed to load data');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // fetchData is correctly in deps
  const updateStatus = useCallback(async (type, id, newStatus) => {
    try {
      await axios.patch(`${API}/${type}/${id}/status`, { status: newStatus });
      toast.success(`Status updated to ${newStatus}`);
      fetchData();
    } catch {
      toast.error('Failed to update status');
    }
  }, [fetchData]);

  return {
    contacts,
    intakes,
    appointments,
    loading,
    fetchData,
    updateStatus,
  };
};

export const filterData = (list, fields, searchTerm) =>
  list.filter((item) =>
    fields.some((f) => {
      const val = f.split('.').reduce((o, k) => o?.[k], item);
      return val?.toString().toLowerCase().includes(searchTerm.toLowerCase());
    })
  );

export const formatDate = (ts) => {
  try {
    return new Date(ts).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return ts;
  }
};
